import { BitmovinPlayerError } from 'components/Player/types.ts';

import SSM from '../Ssm';

function useSsmSession(onError: (error: BitmovinPlayerError) => void) {
    return new SSM(onError);
}

export default useSsmSession;
